import { CheckOutlined } from '@ant-design/icons';
import { Alert, Button, Spin } from 'antd';
import { useCallback, useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import {
  timestampToDate,
  timestampToDateAlert,
  timestampToDateWithoutSecond,
} from '../../common/handleTimestamp';
import alarmController from '../../redux/api/tbAlarmController';

const ModalAlert = ({
  setShow,
  show,
  deviceId,
  newAlert,
  setNewAlert,
  notify,
  setNotify,
}) => {
  const token = localStorage.getItem('token');
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [alertData, setAlertData] = useState([]);

  useEffect(() => {
    if (show) setNotify({ ...notify, unread: 0 });
  }, [alertData]);

  const [alertContent, setAlertContent] = useState();

  const onCheckAlert = async (alarmId) => {
    await alarmController.clearAlarm(token, alarmId);
    fetchData();
  };

  const fetchData = useCallback(async () => {
    setLoading(true);
    const dataAlert = await alarmController.getAlarms(
      token,
      'DEVICE',
      deviceId
    );
    setAlertData(dataAlert?.data);
    setLoading(false);
    setNewAlert(false);

    const html =
      dataAlert?.data?.length > 0 &&
      dataAlert?.data?.map((item, idx) => (
        <Alert
          key={idx}
          type={item.status === 'ACTIVE_UNACK' ? 'error' : 'info'}
          message={item.details}
          description={timestampToDateAlert(item.endTs)}
          style={{ margin: '0 8px 16px' }}
          action={
            item.status === 'ACTIVE_UNACK' ? (
              <Button shape="circle" onClick={() => onCheckAlert(item.id.id)}>
                <CheckOutlined />
              </Button>
            ) : null
          }
        />
      ));
    setAlertContent(html);
  });

  useEffect(() => {
    if (newAlert) {
      fetchData();
    }
  }, [newAlert]);

  useEffect(() => {
    fetchData();
  }, [t]);

  const handleClose = () => setShow(false);
  return (
    <Modal onHide={handleClose} show={show} scrollable>
      <Modal.Header closeButton>
        <Modal.Title>{t('alert')}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Spin spinning={loading}>{alertContent}</Spin>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          {t('close')}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalAlert;
